module.exports = __webpack_public_path__ + "static/media/YB5F11_1.0ca6f170.jpg";